import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
    selector: 'app-no-wallet',
    templateUrl: './no-wallet.component.html',
    styleUrl: './no-wallet.component.scss',
    standalone: false
})
export class NoWalletComponent {
  presale_singular_link: string = environment.presale_singular_link;
  readonly modalRef = inject(BsModalRef);
  private readonly analyticsService = inject(AnalyticsService);

  constructor() {}

  handleSingularLinkClick(): void {
    this.analyticsService.vwoData('singular', { downloadBestwalletPlacement: "Don't have wallet" });
  }
}
